import { render } from "./AllertaCaricamenti.vue?vue&type=template&id=122c0af2&scoped=true"
import script from "./AllertaCaricamenti.vue?vue&type=script&lang=js"
export * from "./AllertaCaricamenti.vue?vue&type=script&lang=js"

import "./AllertaCaricamenti.vue?vue&type=style&index=0&id=122c0af2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122c0af2"]])

export default __exports__